import {
  MOPED_DETAILS_STEP,
  MOPED_INTRO_STEP,
  MOPED_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Moped";

import { MopedCoverage } from "Store/interfaces/products/coverage";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { booleanToFormBoolean } from "Utils/formUtils";
import { isUndefined } from "Utils/functions";
import { getAgeFromDate } from "Validation/dateValidaton";

export const mapFromCommerceMoped = (data: Record<string, any>): FormState => {
  const otherOwnerAge = !data.insuranceHolderIsOwner
    ? getAgeFromDate(new Date(data.owner.dateOfBirth))
    : undefined;

  return {
    [MOPED_INTRO_STEP.id]: {
      registrationYear: String(data.modelYear),
      brand: data.brand,
      model: data.model,
    },
    [MOPED_DETAILS_STEP.id]: {
      insuranceHolderIsOwner: booleanToFormBoolean(data.insuranceHolderIsOwner),
      relation: data.owner?.relation,
      age: otherOwnerAge,
      ...mapInjuriesToForm(data.damageCountRecentYears, data.yearOfLastDamage),
    },
    [MOPED_PRICE_STEP.id]: {
      coverage: isUndefined(data.coverageGroup)
        ? MopedCoverage.MOPED_FULL_OWN_DAMAGE
        : data.coverageGroup,
    },
  };
};
